// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  
  //LOCALHOST
  // production: false,
  // apiEndpoint: 'https://houston.cycler.co.uk',
  // membrsEndpoint: 'https://staging.memb.rs/api/v1',
  // membrsLoginPage: 'https://marketplace-local.staging.memb.rs/login',
  // envName: 'local',
  // cookieDomain: 'localhost',
  // marketplaceUrl: 'https://beta.marketplace.worryandpeace.com'

//Next Gen Dev
  production: false,
  apiEndpoint: 'https://houston.dev.cycler.co.uk',
  membrsEndpoint: 'https://staging.memb.rs/api/v1',
  membrsLoginPage: 'https://apollo11-dev.cycler.co.uk',
  envName: 'prod',
  cookieDomain: '.marketplace.worryandpeace.com',
  // apollo11-dev is served on both domains, so clear the auth cookie from each on logout
  logoutCookieDomains: ['.cycler.co.uk', '.marketplace.worryandpeace.com'],
  marketplaceUrl: 'https://marketplace-dev.worryandpeace.com',
  // Consumer storefront URLs used for "Load Quote" links (dev values)
  cyclerUrl: 'https://dev.cycler.co.uk',
  fullsendCoverUrl: 'https://dev.fullsendcover.com'

  //Next Gen Prod
  // production: false,
  // apiEndpoint: 'https://houston.cycler.co.uk',
  // membrsEndpoint: 'https://staging.memb.rs/api/v1',
  // membrsLoginPage: 'https://apollo11.cycler.co.uk',
  // envName: 'prod',
  // cookieDomain: '.cycler.co.uk',
  // // apollo11-dev is served on both domains, so clear the auth cookie from each on logout
  // logoutCookieDomains: ['.cycler.co.uk'],
  // marketplaceUrl: 'https://admin.cycler.co.uk',
  // // Consumer storefront URLs used for "Load Quote" links (dev values)
  // cyclerUrl: 'https://cycler.co.uk',
  // fullsendCoverUrl: 'https://fullsendcover.com'




 







};



// WEBPACK FOOTER //
// /Users/mattspringbett/sites/cycler/apollo-admin/src/src/environments/environment.ts